import React, { useEffect } from "react";
import BannerExpert from "./Body/BannerExpert";
import { validationLan } from "../../../ValidationLan/ValidationLan";

const Expert = () => {
  let isArabic = localStorage.getItem("lan") === "AR";
  useEffect(() => {
    validationLan();
  }, [isArabic]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <BannerExpert />;
};

export default Expert;
